import type { ErrorInfo, ReactNode } from 'react'
import { Component } from 'react'

interface OwnProps {
  readonly children: ReactNode
  readonly fallback?: ReactNode
  readonly onError?: (error: Error, errorInfo: ErrorInfo) => void
}

interface State {
  readonly hasError: boolean
}

class ErrorBoundary extends Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { onError } = this.props
    onError?.(error, errorInfo)
  }

  render() {
    const { hasError } = this.state
    const { children, fallback } = this.props

    if (hasError) {
      return fallback ?? null
    }

    return children
  }
}

export default ErrorBoundary
